module.exports = __webpack_public_path__ + "img/intelligent-panic.7f388fb3.png";